import { ShiftService, EmployeesService, AccountsService, MasterdataAService } from '../../services';
import * as moment from 'moment';
import { AuthService } from "../../authorization/services/index";

export const customerShiftState: aboTheme.IState = {

  parent: 'app',
  name: "customerShifts",
  url: "/customerShifts",
  component: 'customerShiftComponent',
  redirectTo: 'customerShifts.calendar',
  data: {
    permissions: {
      only: ['CUSTOMER'],
      redirectTo: 'shifts'
    }
  }

};

export const customerShiftCalendarState: aboTheme.IState = {

  name: "customerShifts.calendar",
  url: "/calendar",
  resolve: {
    statuses : (MasterdataAService: MasterdataAService) => { "ngInject"; return MasterdataAService.getItems('ShiftStatus'); }
  },
  views: {
    "main": 'customerShiftCalendarComponent'
  }

};

export const customerShiftCalendarItemState = {

  name: "customerShifts.calendar.item",
  url: "/item/:id",
  modal: true,
  size: "lg",
  component: 'shiftItemComponent',
  resolve: {
    shift: (ShiftService: ShiftService, $stateParams: ng.ui.IStateParamsService) => {
      "ngInject";
      if ($stateParams['id']) {
        return ShiftService.get($stateParams['id']);
      }
    },
    functions: (MasterdataAService: MasterdataAService) => { "ngInject"; return MasterdataAService.getItems('Functions'); },
    accounts: (AccountsService: AccountsService) => { "ngInject"; return AccountsService.all(); },
    employees: (AccountsService: AccountsService, AuthService: AuthService) => {
      'ngInject';
      return AccountsService.customGet('employees');
    },
    statuses: (MasterdataAService: MasterdataAService) => { "ngInject"; return MasterdataAService.getItems('ShiftStatus'); }
  }
};

export const customerShiftListState: aboTheme.IState = {
  name: "customerShifts.list",
  url: "/list",
  views: {
    "main": 'shiftListComponent'
  },
  resolve: {
    functions: (MasterdataAService: MasterdataAService) => { "ngInject"; return MasterdataAService.getItems('Functions'); },
    statuses: (MasterdataAService: MasterdataAService) => { "ngInject"; return MasterdataAService.getItems('ShiftStatus'); },
    accounts: (AccountsService: AccountsService) => { "ngInject"; return AccountsService.all(); },
    employees: (EmployeesService: EmployeesService) => { "ngInject"; return EmployeesService.getEmployeesByStatus(); },
  },
  data: {
    contentClasses: 'no-padding'
  }
};

export const customerShiftListItemState = {

  name: "customerShifts.list.item",
  url: "/item/:id",
  resolve: {
    shift: (ShiftService: ShiftService, $stateParams: ng.ui.IStateParamsService) => {
      "ngInject";
      if ($stateParams['id']) {
        return ShiftService.get($stateParams['id']);
      }
    },
    //functions: (MasterdataAService: MasterdataAService) => { "ngInject"; return MasterdataAService.getItems('Functions'); },
    //statuses: (MasterdataAService: MasterdataAService) => { "ngInject"; return MasterdataAService.getItems('ShiftStatus'); }
  },
  views: {
    "shiflistitem@customerShifts.list": 'shiftListItemComponent'
  },

};


// WEBPACK FOOTER //
// ./src/app/modules/customerShifts/shift.states.ts